import { Box, CircularProgress } from '@mui/material'
import { memo, useState } from 'react'
import { Tweet } from 'react-twitter-widgets'

import Text from '../shared/text/Text'

const TwitterEmbed = ({ t, postId, theme }) => {
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(null)
  return (
    <>
      {(loading || error) && (
        <Box
          sx={{
            display: 'flex',
            p: 3,
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center'
          }}
        >
          {loading && <CircularProgress />}
          {error && (
            <Text
              color='error'
              align='center'
              label={t('earn-via.failed-load-tweet')}
            />
          )}
        </Box>
      )}
      <Box
        sx={{
          width: '100%',
          '& .twitter-tweet': {
            fontFamily: 'inherit !important',
            margin: '0 !important'
          }
        }}
      >
        <Tweet
          tweetId={postId}
          options={{
            conversation: 'none',
            // cards: 'hidden',// to hide image
            theme: theme.palette.mode
          }}
          onLoad={() => setLoading(false)}
          renderError={(err) => setError(err)}
        />
      </Box>
    </>
  )
}

export default memo(TwitterEmbed)
